export const PermissionsConstants = Object.freeze({
    VIEW: 'view',
    LIST: 'list',
    DOWNLOAD: 'download',
    CREATE: 'create',
    EDIT: 'edit',
    DELETE: 'delete',
    LAYERS: 'layers',
    TIMELINE: 'timeline'
});